(function () {
  "use strict";

  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.dataset.mtDelay || 0;
            setTimeout(function () { entry.target.classList.add("mt-visible"); }, Number(delay));
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll("[data-mt-contador]");
    if (!els.length) return;
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var fin = parseFloat(el.dataset.mtContador) || 0;
          var decimales = (el.dataset.mtContador.split(".")[1] || "").length;
          if (reduced) {
            el.textContent = fin.toFixed(decimales);
          } else {
            var inicio = 0;
            var duracion = 1400;
            var t0 = null;
            function paso(ts) {
              if (!t0) t0 = ts;
              var progreso = Math.min((ts - t0) / duracion, 1);
              var ease = 1 - Math.pow(1 - progreso, 3);
              var valor = inicio + (fin - inicio) * ease;
              el.textContent = valor.toFixed(decimales);
              if (progreso < 1) requestAnimationFrame(paso);
            }
            requestAnimationFrame(paso);
          }
          io.unobserve(el);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initGaleriaProducto() {
    var wraps = document.querySelectorAll("[data-mt-galeria]");
    wraps.forEach(function (wrap) {
      var principal = wrap.querySelector("[data-mt-galeria-principal]");
      var thumbs = wrap.querySelectorAll("[data-mt-galeria-thumb]");
      if (!principal || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var full = thumb.dataset.mtGaleriaThumb;
          if (!full) return;
          principal.style.opacity = "0";
          setTimeout(function () {
            principal.src = full;
            principal.style.opacity = "1";
          }, 160);
          thumbs.forEach(function (t) { t.classList.remove("mt-activo"); });
          thumb.classList.add("mt-activo");
        });
      });
    });
  }

  function initVariantes() {
    var forms = document.querySelectorAll("[data-mt-form-producto]");
    forms.forEach(function (form) {
      var dataEl = form.querySelector("[data-mt-variantes-json]");
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = form.querySelector("input[name='id']");
      var precioEl = form.querySelector("[data-mt-precio-actual]");
      var precioAnteriorEl = form.querySelector("[data-mt-precio-anterior]");
      var botonComprar = form.querySelector("[data-mt-boton-comprar]");
      var grupos = form.querySelectorAll("[data-mt-opcion-grupo]");

      function opcionesSeleccionadas() {
        var seleccion = [];
        grupos.forEach(function (grupo) {
          var activo = grupo.querySelector(".mt-seleccionado");
          seleccion.push(activo ? activo.dataset.mtValor : null);
        });
        return seleccion;
      }

      function actualizar() {
        var seleccion = opcionesSeleccionadas();
        var variante = variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === seleccion[i]; });
        });
        if (!variante) return;
        idInput.value = variante.id;
        if (precioEl) precioEl.textContent = formatoDinero(variante.price);
        if (precioAnteriorEl) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioAnteriorEl.textContent = formatoDinero(variante.compare_at_price);
            precioAnteriorEl.style.display = "";
          } else {
            precioAnteriorEl.style.display = "none";
          }
        }
        if (botonComprar) {
          var etiqueta = botonComprar.querySelector("span");
          if (variante.available) {
            botonComprar.disabled = false;
            botonComprar.removeAttribute("aria-disabled");
            if (etiqueta) etiqueta.textContent = botonComprar.dataset.mtTextoDisponible || etiqueta.textContent;
          } else {
            botonComprar.disabled = true;
            botonComprar.setAttribute("aria-disabled", "true");
            if (etiqueta) etiqueta.textContent = botonComprar.dataset.mtTextoAgotado || "Agotado";
          }
        }
      }

      function formatoDinero(centavos) {
        var valor = (centavos / 100).toFixed(2).replace(".", ",");
        return (form.dataset.mtMoneda || "€") + valor;
      }

      grupos.forEach(function (grupo) {
        grupo.querySelectorAll("[data-mt-valor]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            grupo.querySelectorAll("[data-mt-valor]").forEach(function (b) { b.classList.remove("mt-seleccionado"); });
            btn.classList.add("mt-seleccionado");
            actualizar();
          });
        });
      });

      actualizar();
    });
  }

  function initComparador() {
    var wraps = document.querySelectorAll("[data-mt-comparador]");
    wraps.forEach(function (el) {
      var overlay = el.querySelector("[data-mt-comparador-overlay]");
      var handle = el.querySelector("[data-mt-comparador-handle]");
      var imgAntes = overlay ? overlay.querySelector("img") : null;
      if (!overlay || !handle || !imgAntes) return;
      var dragging = false;

      function ajustarAnchoImagen() {
        var rect = el.getBoundingClientRect();
        imgAntes.style.width = rect.width + "px";
      }

      function set(pct) {
        pct = Math.max(0, Math.min(100, pct));
        overlay.style.width = pct + "%";
        handle.style.left = pct + "%";
      }

      function posDesdeEvento(evt) {
        var rect = el.getBoundingClientRect();
        var clientX = evt.touches ? evt.touches[0].clientX : evt.clientX;
        return ((clientX - rect.left) / rect.width) * 100;
      }

      el.addEventListener("pointerdown", function (evt) {
        dragging = true;
        set(posDesdeEvento(evt));
        if (el.setPointerCapture) {
          try { el.setPointerCapture(evt.pointerId); } catch (e) {}
        }
      });
      el.addEventListener("pointermove", function (evt) {
        if (!dragging) return;
        set(posDesdeEvento(evt));
      });
      ["pointerup", "pointerleave", "pointercancel"].forEach(function (nombre) {
        el.addEventListener(nombre, function () { dragging = false; });
      });

      ajustarAnchoImagen();
      set(50);
      window.addEventListener("resize", ajustarAnchoImagen);
    });
  }

  function initFAQ() {
    var items = document.querySelectorAll(".mt-faq-item");
    items.forEach(function (item) {
      var btn = item.querySelector(".mt-faq-pregunta");
      var respuesta = item.querySelector(".mt-faq-respuesta");
      if (!btn || !respuesta) return;
      btn.addEventListener("click", function () {
        var abierto = item.classList.contains("mt-abierto");
        items.forEach(function (i) {
          i.classList.remove("mt-abierto");
          i.querySelector(".mt-faq-respuesta").style.maxHeight = null;
        });
        if (!abierto) {
          item.classList.add("mt-abierto");
          respuesta.style.maxHeight = respuesta.scrollHeight + "px";
        }
      });
    });
  }

  function initParallaxHero() {
    var medias = document.querySelectorAll("[data-mt-parallax]");
    if (!medias.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.innerWidth < 990) return;
    var ticking = false;
    function actualizar() {
      medias.forEach(function (media) {
        var rect = media.closest(".mt-section").getBoundingClientRect();
        var progreso = 1 - (rect.top + rect.height) / (window.innerHeight + rect.height);
        var despl = (progreso - 0.5) * 40;
        media.style.transform = "translateY(" + despl.toFixed(1) + "px) scale(1.08)";
      });
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { requestAnimationFrame(actualizar); ticking = true; }
    }, { passive: true });
    actualizar();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initContadores();
    initGaleriaProducto();
    initVariantes();
    initComparador();
    initFAQ();
    initParallaxHero();
  });
})();
